/**
 * Configuration object returned when the Rovo onboarding config is active.
 *
 * `skipAifc` indicates whether the user arrived via a non-AI-First-Create entry point
 * (i.e. they skipped or came from a Jira cross-flow skip path).
 */
export type OnboardingRovoConfig = {};

type UseOnboardingRovoConfigParams = {
	/** When true, the hook short-circuits and returns null (no config active). */
	skip: boolean;
	/**
	 * Whether the user arrived via a skip entry point ('cc-onboarding-skip' or
	 * 'cc-onboarding-xflow-skip') rather than an AI-First-Create path.
	 * Reserved for future use.
	 */
	skipAifc: boolean;
};

/**
 * Returns an `OnboardingRovoConfig` when the onboarding entry point is active,
 * or `null` when `skip` is true (i.e. no entry point was detected).
 *
 * `skipAifc` is accepted as a parameter for future use but does not currently
 * affect the returned config.
 */
export function useOnboardingRovoConfig({
	skip,
	skipAifc: _skipAifc,
}: UseOnboardingRovoConfigParams): OnboardingRovoConfig | null {
	if (skip) {
		return null;
	}

	return {};
}
